var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loading",
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "center-circle",
    cx: 37.7221,
    cy: 38.2779,
    r: 8,
    transform: "rotate(90 37.7221 38.2779)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "inner-circle"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 37.7221,
    cy: 38.2779,
    r: 18.1778,
    transform: "rotate(69.5747 37.7221 38.2779)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    r: 3.38044,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 19.5232 36.3911)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "outer-circle"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 37.7221,
    cy: 38.2779,
    r: 32.071,
    transform: "rotate(69.5747 37.7221 38.2779)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 66.8408,
    cy: 27.5499,
    r: 5.06815,
    transform: "rotate(90 66.8408 27.5499)",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    fill: "white",
    transform: "translate(76 1.90735e-06) rotate(90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading-icon.894f598198f81f2e3b247a421a8d9185.svg";
export { ForwardRef as ReactComponent };